<template>
  <div>
    <h4 class="mb-0">Jagdzeit</h4>
    <div class="text-muted mb-3">
      Die schönsten Seiten der Jagd
    </div>

    <div style="max-width: 540px;" v-for="(post, i) in jagdzeit.postings" :key="post.id">
      <div class="card mb-3">
        <a :href="post.url" target="_blank">
          <img :src="post.picture" width="200" height="100%" class="card-img-top" v-if="post.picture">
        </a>
        <div class="card-body">
          <a :href="post.url" class="h5 card-title" target="_blank">
            {{ post.title }}
          </a>
          <p class="card-text mt-1">
            {{ post.excerpt | truncate(200) }}
          </p>
        </div>
      </div>

      <div v-if="(i + 1) % 2 === 0">
        <ad :zone="106" class="mt-3 s300x250"></ad>
      </div>
    </div>

    <ad :zone="106" class="mt-3 s300x250"></ad>

    <div class="card mt-2">
      <h4 class="card-header">
        <a href="https://www.jagdjobs.de" target="_blank">
          Jobs aus der Jagdbranche
        </a>
      </h4>
      <div class="card-body">
        <div class="text-center" v-if="jobs.working">
          <div class="spinner-border spinner-border-sm text-muted"></div>
        </div>

        <ul class="list-unstyled">
          <li class="mt-2" v-for="job in jobs.postings" :key="job.id">
            <a :href="'https://www.jagdjobs.de/jobs/' + job.slug" target="_blank">
              {{ job.title }}
            </a>
            <div class="text-muted">
              {{ job.user.name }}, {{ job.location_city }}
            </div>
          </li>
        </ul>

        <div class="text-right">
          &rsaquo;
          <a href="https://www.jagdjobs.de" target="_blank">
            Mehr Jobs
          </a>
        </div>
      </div>
    </div>
    
    <ad :zone="106" class="mt-3 s300x250"></ad>
  </div>
</template>

<script>
  import Ad from '@/vues/helpers/ad.vue';

  export default {
    name: 'Sidebar-Right',
    components: { Ad },
    data () {
      return {
        jagdzeit: {
          working: true,
          postings: []
        },
        jobs: {
          working: true,
          postings: []
        }
      };
    },
    async mounted () {
      await this.loadJagdzeit();
      await this.loadJobs();
    },
    methods: {
      async loadJagdzeit () {
        const params = { imgOptions: JSON.stringify({
          width: 200,
          gravity: { type: 'ce' }
        }) };

        const res = await this.$http.get('posts/jagdzeit', { params });
        this.jagdzeit.postings = res.body;
        this.jagdzeit.working = false;
      },

      async loadJobs () {
        if (process.env.NODE_ENV !== 'development') {
          const res = await this.$http.get('https://www.jagdjobs.de/jobs.json');
          this.jobs.postings = res.body.slice(0,10);
        }

        this.jobs.working = false;
      }
    }
  };
</script>
